import { FunctionComponent } from 'react';
import Button from 'components/UI/V3/Button/Button';
import styles from './OlbIntegrationCard.module.scss';

interface OlbIntegrationCardProps {
    icon: string;
    title: string;
    description: string;
    isConnected: boolean;
    onClick: () => void;
}

const OlbIntegrationCard: FunctionComponent<OlbIntegrationCardProps> = ({
    icon,
    title,
    description,
    isConnected,
    onClick
}) => {
    return (
        <div className={styles.card}>
            <div className={styles.header}>
                <img
                    src={icon}
                    alt={title}
                    className={styles.icon}
                />
                <span className={isConnected ? styles.badgeConnected : styles.badgeDisconnected}>
                    {isConnected ? 'Connected' : 'Not Connected'}
                </span>
            </div>
            <h3 className={styles.title}>{title}</h3>
            <p className={styles.description}>{description}</p>
            <Button
                label={isConnected ? 'Edit' : 'Get Started'}
                variant="black"
                size="medium"
                className={styles.button}
                onClick={onClick}
            />
        </div>
    );
};

export default OlbIntegrationCard;
